import * as form from '../form';

export const legalCourt = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};

    return {
      Item: {
        CivilActionDate: form.datecontrol(xitem.CivilActionDate), 
        ApplicantCourtPartyStatus: form.radio(xitem.ApplicantCourtPartyStatus), // PVQ Only 
        OppositionPartyName: form.name(xitem.OppositionPartyName), // PVQ Only 
        OppositionCourtPartyStatus: form.radio(xitem.OppositionCourtPartyStatus), // PVQ Only 
       
        AdditionalOppositions: form.collection( // PVQ Only 
                  ((xitem.AdditionalOppositions || {}).items || []).map((y) => {
                    const yitem = y.Item || {};
                    return {
                      Item: {
                        Has: form.branch(yitem.Has),
                        OppositionPartyName: form.name(yitem.OppositionPartyName),
                        OppositionCourtPartyStatus: form.radio(yitem.OppositionCourtPartyStatus),
                        
                
                      },
                    };
                  })
                ),
        CourtName: form.text(xitem.CourtName), 
        CourtAddress: form.location(xitem.CourtAddress), 
        NatureOfAction: form.textarea(xitem.NatureOfAction), 
        IsCivilCourtActionClosed: form.branch(xitem.IsCivilCourtActionClosed), // PVQ Only 
        CivilCourtActionClosedDate: form.datecontrol(xitem. CivilCourtActionClosedDate), // PVQ Only 
        OutcomeOfAction: form.checkboxgroup(xitem.OutcomeOfAction), // PVQ Only 
        OutcomeOtherExplanation: form.textarea(xitem.OutcomeOtherExplanation), // PVQ Only 
        ScheduledCourtDate: form.datecontrol(xitem.ScheduledCourtDate), // PVQ Only
        IsCivilActionAPublicRecord: form.branch(xitem.IsCivilActionAPublicRecord), // PVQ Only
        ResultsOfAction: form.textarea(xitem.ResultsOfAction), 
        PrincipalPartyNames: form.textarea(xitem.PrincipalPartyNames),
       
      },
    };
  });
  return {
    HasCourtActions: form.branch(data.HasCourtActions),
    List: form.collection(items, (data.List || {}).branch),
    
  };
};
